/* eslint-disable prettier/prettier */
const TYPES = {
  ADD_CONCEJO: 'ADD_CONCEJO',
  ADD_CONCEJO_SUCCESS: 'ADD_CONCEJO_SUCCESS',
  ADD_CONCEJO_ERROR: 'ADD_CONCEJO_ERROR',
  OBTENER_CONCEJO: 'OBTENER_CONCEJO',
  OBTENER_CONCEJO_SUCCESS: 'OBTENER_CONCEJO_SUCCESS',
  OBTENER_CONCEJO_ERROR: 'OBTENER_CONCEJO_ERROR',
  OBTENER_CONCEJO_EDITAR: 'OBTENER_CONCEJO_EDITAR',
  EDITAR_CONCEJO: 'EDITAR_CONCEJO',
  EDITAR_CONCEJO_SUCCESS: 'EDITAR_CONCEJO_SUCCESS',
  EDITAR_CONCEJO_ERROR: 'EDITAR_CONCEJO_ERROR',
  DELETE_CONCEJO: 'DELETE_CONCEJO',
  DELETE_CONCEJO_SUCCESS: 'DELETE_CONCEJO_SUCCESS',
  DELETE_CONCEJO_ERROR: 'DELETE_CONCEJO_ERROR',
}
export default TYPES
